function searchRecommendation() {
    return new Promise(function(resolve, reject){
        $.ajax({
            type: 'GET',
            dataType: 'json',
            url: ajax_search_object.ajaxurl,
            data: { 
                'action': 'ajaxsearch',
                'searchterm': $('header input.search').val() },
            success: function(data){
                resolve(data);
            },
            error: function(xhr){
                console.log(xhr);
                reject('Error');
            }
    });
    });
}